import { LitElement, html, css } from 'lit';
import OpenSeadragon from 'openseadragon';
import { EXIST_BASE } from './eplib-constants.js';
import { BootstrapCSS } from '../resources/css/bootstrap.css';
import { EplibStyles } from '../resources/css/style.css.js';

/**
 * Retrieves and displays page images for side-by-side viewing with the transcription.
 *
 * @listens eplib-load-facsimile
 * @listens eplib-remove-facsimile
*/

export class EplibFacsimile extends LitElement {

  static get properties() {
    return {
      ...super.properties,
      witnessNote: {
        type: String
      },
      facsimileViewer: {
        type: HTMLElement
      },
      facsimileContainer: {
        type: HTMLElement
      }
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('eplib-load-facsimile', this.loadFacsimile);
    this.addEventListener('eplib-remove-facsimile', this.removeFacsimile);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('eplib-remove-facsimile', this.removeFacsimile);
    this.removeEventListener('eplib-load-facsimile', this.loadFacsimile);
  }

  async firstUpdated() {
    super.firstUpdated();

    this.facsimileViewer = this.shadowRoot.getElementById('facsimile');
    this.facsimileContainer = this.shadowRoot.getElementById('facsimile-container');

    const doc = window.location.pathname.split('/').pop();
  }

  getFacsimileUrl() {
    const root = this.parentElement.parentElement.getRootNode(); // should get us eplib-content-view
    const contentComponent = root.querySelector('eplib-document-content').shadowRoot;
    let imageSrcElement = contentComponent ? contentComponent.querySelector('[data-facs]') : null;
    if(!imageSrcElement){ return null; }
    const facsData = imageSrcElement.getAttribute('data-facs');
    return facsData ? facsData.replace('archivelab.org', 'archive.org').trim() : null;
  }

  loadFacsimile() {
    if (!this.facsimileViewer) {
      return;
    }
    let facsimileUrl = this.getFacsimileUrl();
    if (!facsimileUrl) {
      this.hideViewer();
      return console.log('this.facsimileViewer:', 'no facsimile url');
    }
    this.facsimileViewer.classList.add('loading');
    if (facsimileUrl.endsWith("9999")) {
      this.facsimileViewer.innerHTML =
      `<div class="wrapper" style="background-color: #ecf5f3; width: 75%; display: flex; align-items: center; padding: 2rem;">
        <h4  style="text-align: center; font-style: italic">
          The image for this page is not present in the image set.
        </h4>
      </div>`;
      this.facsimileViewer.classList.remove('loading');
      this.showViewer();
      return console.log('this.facsimileViewer:', 'image missing from image set');
    }

    console.log('this.facsimileViewer:', 'load', facsimileUrl);
    this.removeFacsimile();
    this.showViewer();
    this.facsimileViewer.classList.remove('loading');

    let viewer = OpenSeadragon({
      element: this.facsimileViewer,
      prefixUrl: "../node_modules/openseadragon/build/openseadragon/images/",
      constrainDuringPan: true,
      visibilityRatio: 1,
      minZoomLevel: 1,
      defaultZoomLevel: 1,
      sequenceMode: false,
      showFullPageControl: true,
      showNavigator: true,
      crossOriginPolicy: "Anonymous",
      tileSources: [facsimileUrl + '/info.json'],
      drawer: 'canvas'
    });

    viewer.addHandler('open-failed', event => {
      console.log("failed to open ", facsimileUrl, event);
    });

    viewer.addHandler('open', event => {
      console.log("open ", facsimileUrl, event);
    });
  }

  removeFacsimile() {
    this.hideViewer();
    if (this.facsimileViewer && this.facsimileViewer.hasChildNodes()) {
      for (let child = this.facsimileViewer.firstChild;
           child !== null;
           child = child.nextSibling) {
        this.facsimileViewer.removeChild(child);
      }
    }
  }

  hideViewer() {
    if (this.facsimileContainer) {
      this.facsimileContainer.classList.add('visually-hidden');
    }
  }

  showViewer() {
    if (this.facsimileContainer) {
      this.facsimileContainer.classList.remove('visually-hidden');
    }
  }

  render() {
    return html`
      <div id="facsimile-container">
        <div class="col-md-12 col-lg-12 col-title">
          <h6 id="witness-note">${this.witnessNote}</h6>
        </div>
        <div id="facsimile"/>
      </div>
    `;
  }

  static get styles() {
    return [
      BootstrapCSS,
      EplibStyles,
      css`
      #facsimile {
        width: 40vw;
        height: 83vh;
        background: transparent;
        margin-top: 0px;
      }
      #facsimile.loading::after {
        content: 'loading...';
      }
      #witness-note {
          color: #983722;
      }
      .openseadragon-message {
        word-break: break-all;
        font-size: 1.2rem;
        margin: 3rem;
      }
      `
    ];
  }
}

customElements.define('eplib-facsimile', EplibFacsimile);